import { render, staticRenderFns } from "./TransTotal.vue?vue&type=template&id=1b46bde8&"
import script from "./TransTotal.vue?vue&type=script&lang=js&"
export * from "./TransTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports